import { PropsWithChildren, useRef } from 'react';

import { createInboxStore, InboxContext, InboxProps, InboxStore } from './inboxStore';

type InboxProviderProps = PropsWithChildren<Partial<InboxProps>> & {
  agentId?: string;
};

export const InboxProvider = ({ children, agentId, ...props }: InboxProviderProps) => {
  const storeRef = useRef<InboxStore>(null);

  if (!storeRef.current) {
    storeRef.current = createInboxStore(agentId, props);
  }

  if (storeRef.current?.getState().agentId !== agentId) {
    storeRef.current = createInboxStore(agentId, props);
  }

  return <InboxContext.Provider value={storeRef.current}>{children}</InboxContext.Provider>;
};
